import { render, staticRenderFns } from "./contentUserAllGroupChangeGroup.vue?vue&type=template&id=9b09e620&"
import script from "./contentUserAllGroupChangeGroup.vue?vue&type=script&lang=js&"
export * from "./contentUserAllGroupChangeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports